import Api from "../services/AxiosService";
import { unwrap } from "./envelope";
import type { PennDepartment, PennRegion } from "../types/auth-types/AuthUser";

export async function listDepartments(): Promise<PennDepartment[]> {
  const res = await Api.get("/v1/departments");
  return unwrap<PennDepartment[]>(res.data);
}

export async function listRegions(): Promise<PennRegion[]> {
  const res = await Api.get("/v1/regions");
  return unwrap<PennRegion[]>(res.data);
}
